import Root from './_Root'

export default class Person extends Root
    id: ''
    name: ''
    imdb_url: ''
    total_votes: 0
    type_id: '' # not really used but it's what the backend gives us
    type: '' # Actor or Director, translated from type_id

    constructor: (original) ->
        super original
        Root.Copy(original, @)
